import VendorConfig from './Ivendor-config';

export const vendorConfig: VendorConfig = {
  startTitle: "Find your perfect ChromeOS device",
  startSubtitle: "Make a few selections and we'll show you the best Chromebook, Chromebox or Chromebase for your needs.",
  i18nMultipleSelectionWizardStepSubtitle: "(Choose all that apply)",
  i18nSingleSelectionWizardStepSubtitle: "(Choose one)",
  backButtonText: "BACK",
  startButtonText: "START",
  continueButtonText: "CONTINUE",
  progressBarStep1Text: "Step 1 of 4",
  progressBarStep2Text: "Step 2 of 4",
  progressBarStep3Text: "Step 3 of 4",
  progressBarStep4Text: "Step 4 of 4",
  primaryUseTitle: "What's your line of work?",
  primaryUseTitleIndustryIdentified: "Let's get started!",
  notYourIndustryLinkText: "Not your industry?",
  primaryUseOptionsToDisplay: [
    "Business",
    "Education",
    "Government",
    "Healthcare"
  ],
  primaryUseBusinessTitle: "Business",
  primaryUseEducationTitle: "Education",
  primaryUseGovernmentTitle: "Government",
  primaryUseHealthcareTitle: "Healthcare",

  showFlexLink: false,
  flexLinkUrl: "",

  useCaseTitle: "What do you need from the device?",
  useCaseOptionsToDisplayEdu: [
    "Grade 1-6",
    "Grade 6-12",
    "Teachers / Staff / Higher Education"
  ],
  useCaseGradeSchoolTitle: "Grade 1-6",
  useCaseHighSchoolCollegeTitle: "Grade 6-12",
  useCaseTeachersStaffTitle: "Teachers / Staff / Higher Education",
  useCaseOptionsToDisplayEnterprise: [
    "Contact Center",
    "Kiosk",
    "Signage",
    "Shared Devices",
    "Modern Worker",
    "Other"
  ],

  useCaseFrontlineWorkerTitle: "Frontline",
  useCaseFrontlineWorkerSubtitle: "First point of contact for clients or customers. Require easy access to information fast - and often share devices.",

  useCaseClinicianTitle: "Clinician",
  useCaseClinicianSubtitle: "For medical professionals requiring quick, easy, and secure access to devices when doing rounds and in between patient rooms.",

  useCaseContactCenterTitle: "Contact Center",
  useCaseContactCenterSubtitle: "High communication services with customers via phone, video, web or social media.",

  useCaseKioskTitle: "Kiosk",
  useCaseKioskSubtitle: "Self-service kiosk devices for employees or customers.",
  useCaseKioskAndSignageTitle: "Kiosk and Signage",
  useCaseKioskAndSignageSubtitle: "Self-service kiosk and display devices for employees or customers.",

  useCaseSignageTitle: "Signage",
  useCaseSignageSubtitle: "Display devices for employees or customers.",

  useCaseSharedDevicesTitle: "Shared Devices",
  useCaseSharedDevicesSubtitle: "Devices shared amongst employees.",

  useCaseModernWorkerTitle: "Modern Worker",
  useCaseModernWorkerSubtitle: "Deliver an AI-assisted experience that boosts productivity, without the IT overhead.​ Powerful features that spark productivity across your enterprise.",

  useCaseNotListedTitle: "Other",
  useCaseNotListedSubtitle: "Any other workforce, including information and executive.",

  useCaseOptionsToDisplayHealthcare: [
    "Contact Center",
    "Kiosk",
    "Signage",
    "Clinician",
    "Other"
  ],

  useCaseFrontlineWorkerHealthcareSubtitle: "Frontline workers are the first point of contact for customers. They require easy access to information on a fast, familiar interface - and often share devices.",
  useCaseKioskHealthcareSubtitle: "Streamlined communication with customers and employees through displays and self-service capabilities, providing greater autonomy and increased productivity.",
  needToRunTitle: "How will the device be used?",

  // This changes maybe
  needToRunOptionsToDisplayEnterprise: [
    "Standard Workload",
    "Advanced Workload",
  ],

  needToRunSimpleTitle: "Standard Workload",
  needToRunSimpleSubtitle: "My employees have browser-based needs, they may use: ",
  needToRunAdvancedTitle: "Advanced Workload",
  needToRunAdvancedSubtitle: "My employees have higher processing needs, they may use:",

 needToRunOptionsToDisplayEdu: [
    "Learning Anywhere",
    "Advanced Use",
  ],

  needToRunSimpleTitleEdu: "Learning Anywhere",
  needToRunSimpleSubtitleEdu: "My students have browser based work, they may use:",
  needToRunAdvancedTitleEdu: "Advanced Use",
  needToRunAdvancedSubtitleEdu: "My students, teachers and staff have higher processing needs, they may use:",

  needToRunEntSimpleBulletOne: "Google Workspace apps",
  needToRunEntSimpleBulletTwo: "Web productivity apps",
  needToRunEntSimpleBulletThree: "Web based video conferencing",

  needToRunEntAdvBulletOne: "Installed legacy apps",
  needToRunEntAdvBulletTwo: "Android apps",
  needToRunEntAdvBulletThree: "Virtualization",
  needToRunEntAdvBulletFour: "Multi-tab usage",
  needToRunEntAdvBulletFive: "Local file storage",

  needToRunEduSimpleBullet: "Multiple browser tabs",

  needToRunEduAdvBulletOne: "Content creation/editing",
  needToRunEduAdvBulletTwo: "Coding",
  needToRunEduAdvBulletThree: "Heavy multitasking",
  needToRunEduAdvBulletFour: "External monitor/displays",

  brandsTitle: "Which brand(s) do you prefer?",
  brandNoPreferenceOptionTitle: "All brands",
  resultsTitle: "Your Results",
  resultsSubtitle: "Customized results, just for you.",
  noResultsMessage: "No devices found matching your criteria. Please update your search.",
  topNumberOfItemsMessage: "Top 10 devices based on the use cases and criteria selected",
  topNumberOfItemsMessageMobile: "Showing top 10 devices",
  noAdditionalResultsMsg: "Here are some results that are close to your criteria.",
  shareResultsButtonText: "SEND ME MY RESULTS",
  startOverButtonText: "START OVER",
  loadMoreButtonText: "LOAD MORE",
  filtersTitle: "FILTERS",
  brandsFilterTitle: "Brands",
  featuresFilterTitle: "Features",
  availabilityFilterTitle: "Availability",
  chromebookPlusFilterTitle: "Chromebook Plus",
  instockFilterLabel: "In Stock",
  touchscreenFilterLabel: "Touchscreen",
  osTypesFilterTitle: "OS Type",
  enterpriseFilterLabel: "ChromeOS with Chrome Enterprise Upgrade",
  chromeXFilterLabel: "Chromebox X",
  nonEnterpriseFilterLabel: "ChromeOS",
  formFactorsFilterTitle: "Form Factors",
  chromebaseFilterLabel: "Chromebase",
  chromeboxFilterLabel: "Chromebox",
  clamshellFilterLabel: "Clamshell",
  convertibleFilterLabel: "Convertible",
  tabletFilterLabel: "Tablet",
  chromebookPlusFilterLabel: "Chromebook Plus",
  screenSizesFilterTitle: "Screen Sizes",
  aueLinkUrl: "https://support.google.com/chrome/a/answer/6220366?hl=en#zippy=%2Cacer",
  aueTextBeginning: "Visit google.com to learn more about",
  aueLinkText: "Google's Auto Update Policy",
  aueTextEnd: "for each device.",
  showAUELink: true,
  priceDisclaimerText: "Sorting by price is only an estimate. Please contact a specialist for more accurate pricing.",
  priceSortButtonPrefixText: "Sort By: ",
  priceLowToHighText: "Price - Low to High",
  priceHighToLowText: "Price - High to Low",
  priceSortMobileTitle: "SORT BY",
  i18nViewAdditionalOptions: "View Additional Options",
  i18nHideAdditionalOptions: "Hide Additional Options",
  additionalDetailsHeader: "ADDITIONAL DETAILS",
  deviceSpecsHeader: "SPECS",
  deviceProcessorLabel: "Processor / Chipset:",
  deviceMemoryLabel: "Memory:",
  deviceStorageLabel: "Storage:",
  deviceDisplayLabel: "Display:",
  formFactorsLabel: "Form Factor:",
  osTypeLabel: "OS Type:",
  additionalFeaturesLabel: "Additional Features:",
  deviceDescriptionHeader: "DESCRIPTION",
  deviceLearnMoreButtonText: "LEARN MORE & PURCHASE",
  idealUseCaseTitle: "PERFECT FOR",
  selectionsTitle: "YOUR SELECTIONS",
  selectedIndustryLabel: "Industry:",
  selectedActivitiesLabel: "Activities:",
  selectedWorkerLabel: "Worker:",
  selectedBrandLabel: "Brand:",
  shareResultsDialogTitle: "Where should your results be sent?",
  shareResultsEmailLabel: "Email Address",
  shareResultsEmailErrorMessage: "Valid email address required",
  shareResultsFirstNameLabel: "First Name",
  shareResultsLastNameLabel: "Last Name",
  shareResultsCompanyNameLabel: "Company Name",
  shareResultsRequiredMessage: "Required",
  shareResultsSubmitButtonText: "SEND ME MY RESULTS",
  shareResultsCancelButtonText: "CANCEL",
  shareResultsConfirmationTitle: "Your results have been emailed to you.",
  shareResultsConfirmationBody: "We’re here to help. If you would like to set up some time to review your results and/or learn about the next steps for adopting ChromeOS devices, please reach out to Chrome@insight.com and we’ll get in touch.",
  shareResultsConfirmationClosing: "Please also check out the resources listed at the bottom of your results page for more information about how Insight can help make a seamless transition to ChromeOS.",
  shareResultsConfirmationCloseButtonText: "CLOSE",
  shareResultsOptInCheckboxLabel: "I consent to receive Insight marketing emails",
  countriesThatRequireOptIn: ["ca"],

  chromebook: "Chromebook",
  notebook: "Notebook",
  notebookFlipDesign: "Notebook - flip design",
  chromebookFlipDesign: "Chromebook - flip design",
  chromebookDetachableKeyboard: "Chromebook - with detachable keyboard",
  chromebookNoKeyboard: "Chromebook - no keyboard",
  chromebookLayFlatDesign: "Chromebook - lay-flat design",
  chromebox: "Chromebox",
  personalComputer: "Personal computer",
  tabletNoKeyboard: "Tablet - no keyboard",
  tablet: "Tablet",
  touchscreenFeatureText: "touchscreen",

  acerDataSourceName: "ACER AMERICA",
  acerDisplayName: "Acer",
  aOpenDataSourceName: "AOPEN",
  aOpenDisplayName: "AOpen",
  asusDataSourceName: "ASUS",
  asusDisplayName: "ASUS",
  dellDataSourceName: "DELL",
  dellDisplayName: "Dell",
  googleDataSourceName: "GOOGLE",
  googleDisplayName: "Google",
  hpDataSourceName: "HP INC",
  hpDisplayName: "HP",
  lenovoDataSourceName: "LENOVO",
  lenovoDisplayName: "Lenovo",
  samsungDataSourceName: "SAMSUNG",
  samsungDisplayName: "Samsung",

  materialTileRippleColor: "rgba(149,207,238,0.08)",
  wizardStepSubtitleBeginning: "(Choose ",
  multipleSelectionWizardStepSubtitleMiddle: "all that apply",
  multipleSelectionWizardStepSubtitleEnd: ")",
  singleSelectionWizardStepSubtitleMiddle: "one",
  singleSelectionWizardStepSubtitleEnd: ")",
  //  This changes
  brandsOptionsToDisplay: [
    "Lenovo",
    "Acer",
    "ASUS",
    "Dell",
    "HP",
    "Samsung",
    "Google"
  ],
  pricingCalculatorURL: "https://chromeenterprise.google/devices/tco-calculator/",
  viewAdditionalOptionsBeginning: "View ",
  hideAdditionalOptionsBeginning: "Hide ",
  additionalOptionsEnd: " Additional Options",
  deviceLearnMoreButtonScreenReaderPrefix: "Learn more about ",
  intelM3: "m3",
  intelCeleron: "Celeron",
  intelCeleronN4000: "Celeron N4000",
  intelCeleronN4020: "Celeron N4020",
  intelCeleronN4100: "Celeron N4100",
  intelCeleronN4120: "Celeron N4120",
  intelCeleronN4500: "Celeron N4500",
  intelCeleronN5100: "Celeron N5100",
  intelPentium: "Pentium",
  intelPentiumN6000: "Pentium Silver N6000",
  inteli3: "i3",
  inteli5: "i5",
  inteli7: "i7",
  amdRyzen: "Ryzen",
  amdRyzen3: "Ryzen 3",
  amdRyzen5: "Ryzen 5",
  amdRyzen7: "Ryzen 7",
  amdA4: "A4",
  amdA6: "A6",
  amd: "AMD",
  amdAthlon: "AMD Athlon",
  mediatrek500: "Media Trek Kompanio 500",
  amd3015Ce: "3015Ce",
  mediaTekMT8183: "MediaTek MT8183",
  qualcomm7c: "Qualcomm Snapdragon 7c",

  frontlineWorkerMinScreenSize: 12,
  frontlineWorkerMaxScreenSize: 15.9,

  kioskMinScreenSize: 12,
  kioskMaxScreenSize: 15.9,

  signageMinScreenSize: 12,
  signageMaxScreenSize: 15.9,

  sharedDevicesMinScreenSize: 12,
  sharedDevicesMaxScreenSize: 15.9,

  modernWorkerMinScreenSize: 12,
  modernWorkerMaxScreenSize: 15.9,

  informationWorkerMinScreenSize: 13,
  informationWorkerMaxScreenSize: 15.9,
  informationWorkerMinStorage: 128,

    // This changes.
  informationWorkerRequiresFingerprintSensor: false,
  informationWorkerRequiresPrivacyScreen: false,
  informationWorkerRequiresBacklitKeyboard: false,

  executiveMobileWorkerMinScreenSize: 12,
  executiveMobileWorkerMaxScreenSize: 14.9,
  // This changes by vendor add the changes to the functions in the mappers.
  executiveMobileWorkerRequiresFingerprintSensor: false,
  executiveMobileWorkerRequiresPrivacyScreen: false,
  executiveMobileWorkerRequiresBacklitKeyboard: false,
  executiveMobileWorkerRequiresStylus: false,

  simpleTasksMinRam: 4,
  simpleTasksPriority: 1,

  advancedTasksMinRam: 8,
  advancedTasksPriority: 2,

  basicClassroomUseMinRAM: 4,
  basicClassroomUsePriority: 1,

  learningAnywhereMinRAM: 4,
  learningAnywherePriority: 2,

  advancedClassroomUseMinRAM: 8,
  advancedClassroomUsePriority: 3,

  deviceResultsToDisplay: 5,

  showAddToCartButton: false,
  showIncludeEnterpriseLicenseBox: false,
  showSaveResultsButton: false,
  subscriptionLicenses: [],
  defaultSubscriptionCheck: 0,
  showShareResultsButton: false,
  showInStockInfo: false
};

export const vendorConfigFr: VendorConfig = {
  defaultSubscriptionCheck: 0,
  kioskMaxScreenSize: 0,
  kioskMinScreenSize: 0,
  signageMinScreenSize: 12,
  signageMaxScreenSize: 15.9,

  sharedDevicesMinScreenSize: 12,
  sharedDevicesMaxScreenSize: 15.9,

  modernWorkerMinScreenSize: 12,
  modernWorkerMaxScreenSize: 15.9,
  showSaveResultsButton: false,
  showShareResultsButton: false,
  subscriptionLicenses: [],
  startTitle: "Trouvez l’appareil ChromeOS parfait pour vous",
  startSubtitle: "Faites quelques sélections et nous vous montrerons le meilleur Chromebook, Chromebox ou Chromebase pour vos besoins.",
  i18nMultipleSelectionWizardStepSubtitle: "(Choisir tous les appareils qui s’appliquent)",
  i18nSingleSelectionWizardStepSubtitle: "(Choisir un appareil)",
  backButtonText: "RETOUR",
  startButtonText: "DÉMARRER",
  continueButtonText: "CONTINUER",
  progressBarStep1Text: "Étape 1 de 5",
  progressBarStep2Text: "Étape 2 sur 5",
  progressBarStep3Text: "Étape 3 sur 5",
  progressBarStep4Text: "Étape 4 sur 5",
  primaryUseTitle: "Quel est votre secteur d’activité?",
  primaryUseTitleIndustryIdentified: "Commençons!",
  notYourIndustryLinkText: "Ce n’est pas votre secteur d’activité?",
  primaryUseOptionsToDisplay: [
    "Affaires",
    "Éducation",
    "Gouvernement",
    "Soins de santé"
  ],
  primaryUseBusinessTitle: "Affaires",
  primaryUseEducationTitle: "Éducation",
  primaryUseGovernmentTitle: "Gouvernement",
  primaryUseHealthcareTitle: "Soins de santé",

  showFlexLink: false,
  flexLinkUrl: "",

  useCaseTitle: "Qui utilisera l’appareil?",
  useCaseOptionsToDisplayEdu: [
    "Grade 1-6",
    "Grade 6-12",
    "Teachers / Staff / Higher Education"
  ],
  useCaseGradeSchoolTitle: "Grade 1-6",
  useCaseHighSchoolCollegeTitle: "Grade 6-12",
  useCaseTeachersStaffTitle: "Teachers / Staff / Higher Education",

  useCaseOptionsToDisplayEnterprise: [
    "De première ligne",
    "Kiosque et affiche",
    "Centre de contact",
    "Other"
  ],
  useCaseFrontlineWorkerTitle: "De première ligne",
  useCaseFrontlineWorkerSubtitle: "Augmentez l’efficacité de première ligne avec des appareils ChromeOS rapides et un accès rapide aux applications.",
  useCaseContactCenterTitle: "Centre de contact",
  useCaseContactCenterSubtitle: "Déploiement et gestion simples, tout en assurant la producivité de l'agent.",
  useCaseClinicianTitle: "Clinicien",
  useCaseClinicianSubtitle: " Pour les professionnels de la santé qui ont besoin d’un accès rapide, facile et sécurisé aux appareils lorsqu’ils font leurs tournées et entre les chambres des patients.",

  useCaseKioskTitle: "Kiosque",
  useCaseKioskSubtitle: "Fournis des capacités de libre-service uniformisées pour améliorer les expériences des employés au moyen d’économies de temps, de la facilité d’utilisation et de la gestion.",
  useCaseKioskAndSignageTitle: "Kiosque et affiche",
  useCaseKioskAndSignageSubtitle: "Fournis des capacités de libre-service uniformisées pour améliorer les expériences des employés au moyen d’économies de temps, de la facilité d’utilisation et de la gestion.",
  useCaseSignageTitle: "Affiche",
  useCaseSignageSubtitle: "Fournis des capacités de libre-service uniformisées pour améliorer les expériences des employés au moyen d’économies de temps, de la facilité d’utilisation et de la gestion.",

  useCaseSharedDevicesTitle: "Appareils partagés",
  useCaseSharedDevicesSubtitle: "Appareils partagés entre les employés.",

  useCaseModernWorkerTitle: "Travailleur moderne",
  useCaseModernWorkerSubtitle: "Pour la main-d’œuvre moderne.",

  useCaseNotListedTitle: "Other",
  useCaseNotListedSubtitle: "Any other workforce, including information and executive.",

  needToRunTitle: "Comment l’appareil sera-t-il utilisé?",
  needToRunOptionsToDisplayEnterprise: [
    "Standard Workload",
    "Advanced Workload",
  ],

  needToRunSimpleTitle: "Standard Workload",
  needToRunSimpleSubtitle: "My employees are using ",

  needToRunAdvancedTitle: "Advanced Workload",
  needToRunAdvancedSubtitle: "My employees need access to ",


  needToRunSimpleTitleEdu: "Learning Anywhere",
  needToRunSimpleSubtitleEdu: "Classroom and distance learning devices",
  needToRunAdvancedTitleEdu: "Advanced use",
  needToRunAdvancedSubtitleEdu: "Teachers, staff, higher education, high school devices",

  needToRunEntSimpleBulletOne: "Google Workspace apps",
  needToRunEntSimpleBulletTwo: "Web productivity apps",
  needToRunEntSimpleBulletThree: "Web based video conferencing",

  needToRunEntAdvBulletOne: "Installed legacy apps",
  needToRunEntAdvBulletTwo: "Android apps",
  needToRunEntAdvBulletThree: "Virtualization",
  needToRunEntAdvBulletFour: "Multi-tab usage",
  needToRunEntAdvBulletFive: "Local file storage",

  needToRunEduSimpleBullet: "Multiple browser tabs",

  needToRunEduAdvBulletOne: "Content creation/editing",
  needToRunEduAdvBulletTwo: "Coding",
  needToRunEduAdvBulletThree: "Heavy multitasking",
  needToRunEduAdvBulletFour: "External monitor/displays",

  useCaseOptionsToDisplayHealthcare: [
  "De première ligne",
  "Centre de contact",
  "Kiosque et affiche",
  "Clinicien",
  "Other"
],

  useCaseFrontlineWorkerHealthcareSubtitle: "Augmentez l’efficacité de première ligne avec des appareils ChromeOS rapides et un accès rapide aux applications.",
  useCaseKioskHealthcareSubtitle: "Fournis des capacités de libre-service uniformisées pour améliorer les expériences des employés au moyen d’économies de temps, de la facilité d’utilisation et de la gestion.",

  needToRunOptionsToDisplayEdu: [
    "Learning Anywhere",
    "Advanced use",
  ],

  brandsTitle: "Quelle(s) marque(s) préférez-vous?",
  brandNoPreferenceOptionTitle: "Pas de préférence",
  resultsTitle: "Vos Résultats",
  resultsSubtitle: "Des résultats personnalisés, rien que pour vous.",
  noResultsMessage: "Aucun appareil trouvé correspondant à vos critères. Veuillez mettre votre recherche à jour.",
  topNumberOfItemsMessage: "Top 10 des appareils en fonction des cas d’utilisation / critères sélectionnés",
  topNumberOfItemsMessageMobile: "Affichage des 10 meilleurs appareils",
  noAdditionalResultsMsg: "Voici quelques résultats proches de vos critères.",
  shareResultsButtonText: "ENVOYEZ-MOI MES RÉSULTATS",
  startOverButtonText: "RECOMMENCER",
  loadMoreButtonText: "CHARGER PLUS",
  filtersTitle: "FILTRES",
  brandsFilterTitle: "Marques",
  featuresFilterTitle: "Caractéristiques",
  availabilityFilterTitle: "Disponibilité",
  chromebookPlusFilterTitle: "Chromebook Plus",
  instockFilterLabel: "en stock",
  touchscreenFilterLabel: "Écran tactile",
  osTypesFilterTitle: "Système d'exploitation fourni / Type",
  enterpriseFilterLabel: "ChromeOS avec la mise à niveau Chrome Enterprise",
  chromeXFilterLabel: "Chromebox X",
  nonEnterpriseFilterLabel: "ChromeOS",
  formFactorsFilterTitle: "Facteurs de forme",
  chromebaseFilterLabel: "Chromebase",
  chromeboxFilterLabel: "Chromebox",
  clamshellFilterLabel: "Clapet",
  convertibleFilterLabel: "Convertible",
  tabletFilterLabel: "Tablette",
  chromebookPlusFilterLabel: "Chromebook Plus",
  screenSizesFilterTitle: "Tailles d'écran",
  aueLinkUrl: "https://support.google.com/chrome/a/answer/6220366?hl=en#zippy=%2Cacer",
  aueTextBeginning: "Visitez google.com pour en savoir plus sur",
  aueLinkText: "la politique de mise à jour automatique de Google",
  aueTextEnd: "pour chaque appareil.",
  showAUELink: true,
  priceDisclaimerText: "Le tri par prix n’est qu’une estimation. Veuillez contacter un spécialiste pour des prix plus précis.",
  priceSortButtonPrefixText: "Trier par: ",
  priceLowToHighText: "Prix - Faible à Élevé",
  priceHighToLowText: "Prix - Élevé à faible",
  priceSortMobileTitle: "Trier par",
  i18nViewAdditionalOptions: "Afficher les options supplémentaires",
  i18nHideAdditionalOptions: "Masquer les options supplémentaires",
  additionalDetailsHeader: "DÉTAILS SUPPLÉMENTAIRES",
  deviceSpecsHeader: "SPÉCIFICATIONS",
  deviceProcessorLabel: "Processeur/Jeu de puces:",
  deviceMemoryLabel: "Mémoire:",
  deviceStorageLabel: "Stockage:",
  deviceDisplayLabel: "Affichage:",
  formFactorsLabel: "Facteur de forme:",
  osTypeLabel: "Système d'exploitation fourni / Type:",
  additionalFeaturesLabel: "Caractéristiques Supplémentaires:",
  deviceDescriptionHeader: "LA DESCRIPTION",
  deviceLearnMoreButtonText: "EN SAVOIR PLUS",
  idealUseCaseTitle: "PARFAIT POUR",
  selectionsTitle: "VOS SÉLECTIONS",
  selectedIndustryLabel: "Industrie:",
  selectedActivitiesLabel: "Activités:",
  selectedWorkerLabel: "Employé:",
  selectedBrandLabel: "Marque:",
  shareResultsDialogTitle: "Où vos résultats doivent-ils être envoyés?",
  shareResultsEmailLabel: "Adresse de courriel",
  shareResultsEmailErrorMessage: "Adresse de courriel valide requise",
  shareResultsFirstNameLabel: "Prénom",
  shareResultsLastNameLabel: "Nom de famille",
  shareResultsCompanyNameLabel: "Nom de la compagnie",
  shareResultsRequiredMessage: "Obligatoire",
  shareResultsSubmitButtonText: "ENVOYEZ-MOI MES RÉSULTATS",
  shareResultsCancelButtonText: "ANNULER",
  shareResultsConfirmationTitle: "Vos résultats vous ont été envoyés par courriel.",
  shareResultsConfirmationBody: "Nous sommes là pour vous aider. Si vous souhaitez prendre le temps d’examiner vos résultats et/ou d’en savoir plus sur les prochaines étapes pour adopter les appareils Chrome OS, veuillez envoyer un message au Chrome@insight.com et nous vous contacterons.",
  shareResultsConfirmationClosing: "Veuillez également consulter les ressources répertoriées au bas de votre page de résultats pour plus d’informations sur la façon dont Insight peut vous aider à effectuer une transition transparente vers ChromeOS.",
  shareResultsConfirmationCloseButtonText: "FERMER",
  shareResultsOptInCheckboxLabel: "Abonnez-vous pour un aperçu de l’univers de la Technologie intelligente™",
  countriesThatRequireOptIn: [
    "ca"
  ],
  chromebook: "Chromebook",
  notebook: "Ordinateur portable",
  notebookFlipDesign: "Ordinateur portable - conception inclinable",
  chromebookFlipDesign: "Chromebook - conception inclinable",
  chromebookDetachableKeyboard: "Chromebook - avec clavier détachable",
  chromebookNoKeyboard: "Chromebook - aucun clavier",
  chromebookLayFlatDesign: "Chromebook - Conception à plat",
  chromebox: "Chromebox",
  personalComputer: "Ordinateur personnel",
  tabletNoKeyboard: "Tablette - aucun clavier",
  tablet: "Tablet",
  touchscreenFeatureText: "écran tactile",
  acerDataSourceName: "ACER AMERICA",
  acerDisplayName: "Acer",
  aOpenDataSourceName: "AOPEN",
  aOpenDisplayName: "AOpen",
  asusDataSourceName: "ASUS",
  asusDisplayName: "ASUS",
  dellDataSourceName: "DELL",
  dellDisplayName: "Dell",
  googleDataSourceName: "GOOGLE",
  googleDisplayName: "Google",
  hpDataSourceName: "HP INC",
  hpDisplayName: "HP",
  lenovoDataSourceName: "LENOVO",
  lenovoDisplayName: "Lenovo",
  samsungDataSourceName: "SAMSUNG",
  samsungDisplayName: "Samsung",
  materialTileRippleColor: "rgba(149,207,238,0.08)",
  wizardStepSubtitleBeginning: "(Choose ",
  multipleSelectionWizardStepSubtitleMiddle: "all that apply",
  multipleSelectionWizardStepSubtitleEnd: ")",
  singleSelectionWizardStepSubtitleMiddle: "one",
  singleSelectionWizardStepSubtitleEnd: ")",
  brandsOptionsToDisplay: [
    "Lenovo",
    "Acer",
    "ASUS",
    "Dell",
    "HP",
    "Samsung"
  ],
  pricingCalculatorURL: "https://chromeenterprise.google/devices/tco-calculator/",
  viewAdditionalOptionsBeginning: "View ",
  hideAdditionalOptionsBeginning: "Hide ",
  additionalOptionsEnd: " Additional Options",
  deviceLearnMoreButtonScreenReaderPrefix: "Learn more about ",
  intelM3: "m3",
  intelCeleron: "Celeron",
  intelCeleronN4000: "Celeron N4000",
  intelCeleronN4020: "Celeron N4020",
  intelCeleronN4100: "Celeron N4100",
  intelCeleronN4120: "Celeron N4120",
  intelCeleronN4500: "Celeron N4500",
  intelCeleronN5100: "Celeron N5100",
  intelPentium: "Pentium",
  intelPentiumN6000: "Pentium Silver N6000",
  inteli3: "i3",
  inteli5: "i5",
  inteli7: "i7",
  amdRyzen: "Ryzen",
  amdRyzen3: "Ryzen 3",
  amdRyzen5: "Ryzen 5",
  amdRyzen7: "Ryzen 7",
  amdA4: "A4",
  amdA6: "A6",
  amd: "AMD",
  amdAthlon: "AMD Athlon",
  mediatrek500: "Media Trek Kompanio 500",
  amd3015Ce: "3015Ce",
  mediaTekMT8183: "MediaTek MT8183",
  qualcomm7c: "Qualcomm Snapdragon 7c",
  frontlineWorkerMinScreenSize: 12,
  frontlineWorkerMaxScreenSize: 15.9,
  informationWorkerMinScreenSize: 13,
  informationWorkerMaxScreenSize: 15.9,
  informationWorkerMinStorage: 128,
  informationWorkerRequiresFingerprintSensor: true,
  informationWorkerRequiresPrivacyScreen: true,
  informationWorkerRequiresBacklitKeyboard: true,
  executiveMobileWorkerMinScreenSize: 12,
  executiveMobileWorkerMaxScreenSize: 14.9,
  executiveMobileWorkerRequiresFingerprintSensor: true,
  executiveMobileWorkerRequiresPrivacyScreen: true,
  executiveMobileWorkerRequiresBacklitKeyboard: true,
  executiveMobileWorkerRequiresStylus: true,
  simpleTasksMinRam: 4,
  simpleTasksPriority: 1,

  advancedTasksMinRam: 8,
  advancedTasksPriority: 2,
  basicClassroomUseMinRAM: 4,
  basicClassroomUsePriority: 1,
  learningAnywhereMinRAM: 4,
  learningAnywherePriority: 2,
  advancedClassroomUseMinRAM: 8,
  advancedClassroomUsePriority: 3,
  deviceResultsToDisplay: 5,
  showAddToCartButton: false,
  showIncludeEnterpriseLicenseBox: false,
  showInStockInfo: false
};
